import { parseURL } from '@/helpers/utils';

export const processURLInfo = (urlObj, supportedSchemes, defaultScheme = 'http') => {
  const { url } = urlObj;
  const parsed = parseURL(url);
  const result = {
    showDetails: urlObj.showDetails,
  };

  let path = parsed.path.replace(/\/\/+/g, '/');
  path = path === '/' ? '' : path;

  let hostPath = parsed.port ? `${parsed.host}:${parsed.port}${path}` : `${parsed.host}${path}`;
  if (parsed.query || parsed.fragment) {
    hostPath += `?${parsed.query}${parsed.fragment}`;
  }

  hostPath = hostPath.replace(/^\/+/g, '') || '';
  result.hostPath = hostPath;

  let scheme = parsed.protocol;
  switch (scheme) {
    case 'http':
    case 'ftp':
    case 'aspera':
    case 'origin':
    case 'azure':
    case 'rtmp':
    case 'upd':
    case 'srt':
    case 'http+hls':
      result.selectedType = scheme;
      result.secure = false;
      break;
    case 'https':
      result.selectedType = 'http';
      result.secure = true;
      break;
    case 'https+hls':
      result.selectedType = 'http+hls';
      result.secure = true;
      break;
    case 'sftp':
      result.selectedType = 'ftp';
      result.secure = true;
      break;
    default:
      scheme = defaultScheme;
      result.secure = false;
      result.selectedType = defaultScheme;
  }

  // eslint-disable-next-line no-prototype-builtins
  if (!supportedSchemes.hasOwnProperty(scheme)) {
    scheme = defaultScheme;
    result.secure = false;
    result.selectedType = defaultScheme;
  }

  const { login, password } = parsed;
  result.login = login || '';
  result.password = password || '';

  let lp = '';
  if (login) {
    lp = password ? `${login}:${password}@` : `${login}@`;
  }
  result.url = `${scheme}://${lp}${hostPath}`;
  return result;
};
